import { clearNewDocumentoSettingsState } from "features/Crear/redux/slices/newDocumentoSettingsSlice"
import {
  clearLibrado,
  clearNewDocumentoState,
  setDocumentToContact,
  setLibrado,
  setLibrador,
  stateConvertirNextDoc,
} from "features/Crear/redux/slices/newDocumentoSlice"
import { convertirUserContact } from "features/Crear/utils/convertirUserContact"
import { useDispatch } from "hooks/useDispatch"
import { useHistory } from "react-router-dom"

const useCrearDocumento = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const crearDocumento = (route: $TSMigrationFixMe) => {
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(stateConvertirNextDoc(true))
    dispatch(clearNewDocumentoState())
    dispatch(clearLibrado())
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(clearNewDocumentoSettingsState())

    history.push(route)
  }

  const crearDocumentoConLibrado = (
    route: $TSMigrationFixMe,
    dataLibrado: $TSMigrationFixMe,
    dataLibrador: $TSMigrationFixMe
  ) => {
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(stateConvertirNextDoc(true))
    dispatch(clearNewDocumentoState())
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(setDocumentToContact(true))
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(setLibrado(convertirUserContact(dataLibrado)))
    dispatch(setLibrador(dataLibrador))
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(clearNewDocumentoSettingsState())

    history.push(route)
  }

  const crearDocumentoConLibrador = (
    route: $TSMigrationFixMe,
    dataLibrado: $TSMigrationFixMe,
    dataLibrador: $TSMigrationFixMe
  ) => {
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(stateConvertirNextDoc(true))
    dispatch(clearNewDocumentoState())
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(setDocumentToContact(true))
    dispatch(setLibrado(dataLibrado))
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(setLibrador(convertirUserContact(dataLibrador)))
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(clearNewDocumentoSettingsState())

    history.push(route)
  }

  return { crearDocumento, crearDocumentoConLibrado, crearDocumentoConLibrador }
}

export default useCrearDocumento
